
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Pending',
  props: {
    color: {
      type: String,
      required: false,
      default: '',
    },
    width: {
      type: Number,
      required: false,
      default: 24,
    },
    heigth: {
      type: Number,
      required: false,
      default: 24,
    },
  },
});
